/* eslint-disable */
export default {
  noResultFoundFor: 'Geen resultaat gevonden voor',
  search: 'Zoeken',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
